module.exports = __webpack_public_path__ + "static/github-9471eed476048215e9acd4d26645c786.png";